import {
  FormHelperText,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { TableRadiosProps } from "../../models/form.model";
import { useRef } from "react";

export default function FormTableRadios(props: TableRadiosProps) {
  const { control, options, name = "", dataTestId } = props;
  const divRef = useRef<HTMLDivElement>(null);

  // const onRadioClick = (i: number) => {
  //   const columns = divRef.current?.querySelectorAll<HTMLHeadElement>('thead th')
  //   const nextColumnWidth = columns?.[i]?.offsetWidth || 0;
  //   divRef.current?.scrollBy({ left: nextColumnWidth, behavior: 'smooth' })
  // }

  return (
    <div ref={divRef} className="padding-b-big" style={{ overflowX: "auto" }}>
      <Table className="radio-table" stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell key={"empty"} align="center"></TableCell>
            {(options[0].subOptions || []).map((column) => (
              <TableCell key={column.key} align="center">
                {props.localizedText(column.key, column.label)}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {options.map((column, optionIndex) => {
            return (
              <TableRow
                tabIndex={-1}
                key={column.key}
                data-testid={`${dataTestId || name}-group${optionIndex}`}
              >
                <TableCell>
                  {props.localizedText(column.key, column.label)}
                </TableCell>
                {(column.subOptions || []).map((item, index) => {
                  return (
                    <TableCell key={item.key} align="center">
                      <Controller
                        name={`${name}${column.key}`}
                        control={control}
                        render={({
                          field: { onChange, value = "" },
                          fieldState: { error },
                          formState,
                        }) => (
                          <Radio
                            value={item.key}
                            checked={value === item.key}
                            onChange={(e) => {
                              onChange(
                                value === item.key ? "" : e.target.value,
                              );
                              // onRadioClick(index)
                            }}
                            data-testid={`${
                              dataTestId || name
                            }-group${optionIndex}-option${index}`}
                          />
                        )}
                      />
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <FormHelperText>Horizontal scroll to see all options</FormHelperText>
    </div>
  );
}
